module.exports = __webpack_public_path__ + "img/icon_device1.8a348871.png";